import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { IconName, Tag } from '@optimus-web/core';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { canCurrentProfileViewSensitiveReports } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { useCommanderSelector } from '@mews-commander/utils';
import { createListItemWithLink } from '../helpers';

export const BIMenuItem = () => {
    const canViewSensitiveReports = useCommanderSelector(canCurrentProfileViewSensitiveReports);
    const BIEnabled = useFeatureFlag(FeatureFlag.insightsEnabled);

    if (!canViewSensitiveReports || !BIEnabled) return null;

    return createListItemWithLink({
        text: 'Mews BI',
        iconName: IconName.PowerBi,
        path: 'BusinessIntelligence',
        isMainItem: true,
        label: (
            <Tag variant="primary">
                <LocalizedText textKey={TextKey.Beta} />
            </Tag>
        ),
    });
};

export default BIMenuItem;
